import CoverageDetailsTemplate from "@components/CoverageDetailsTemplate";

const AccidentalDisability = () => {
  return (
    <CoverageDetailsTemplate
      slug="accidental-disability"
      title="Invalidez permanente total ou parcial por acidente"
      subtitle="Cobertura para casos de acidentes pessoais onde o segurado tornou-se inválido permanente ou seja, com a perda definitiva total ou parcial das funções de algum membro"
      iconPath="/benefits/fractured_thumbs_up.svg"
    >
      <h4>Invalidez por Acidente</h4>
      <p>
        Esta cobertura é específica em casos de acidentes pessoais onde o
        segurado tornou-se inválido permanente, ou seja, com a perda definitiva
        total ou parcial das funções de algum membro, órgão ou parte do corpo,
        impedindo-o de executar suas tarefas profissionais.
      </p>

      <h4>Eligibilidade</h4>
      <p>18 até 65 anos</p>

      <h4>Valor da indenização</h4>
      <p>
        O valor de indenização para esta cobertura é determinado de acordo com a
        sua escolha de plano ao realizar a contratação. <br></br>
        Para receber a indenização desta cobertura é preciso que a lesão física
        causada pelo acidente pessoal que levou a invalidez seja atestada por
        declaração médica.
      </p>

      <p>
        <strong>IMPORTANTE: </strong>Quando o valor de indenização ao segurado
        for de 100% do valor total da cobertura contratada, a apólice de seguro
        será totalmente cancelada.
      </p>

      <h4>Carência</h4>
      <p>Não há carências para essa cobertura</p>
    </CoverageDetailsTemplate>
  );
};

export default AccidentalDisability;
